import { render, staticRenderFns } from "./ResultScreen.vue?vue&type=template&id=3abdb901&scoped=true&"
import script from "./ResultScreen.vue?vue&type=script&lang=js&"
export * from "./ResultScreen.vue?vue&type=script&lang=js&"
import style0 from "./ResultScreen.vue?vue&type=style&index=0&id=3abdb901&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abdb901",
  null
  
)

export default component.exports